export const PLAN_KEYS = {
    free: 'free',
    basic: 'basic',
    professional: 'professional',
};

// Restrictions computed per plan.
// maxDiagrams / maxSeats / maxTeams: -1 means unlimited.
export const PLAN_RESTRICTIONS = {
    free: {
        maxDiagrams: 3,
        maxSeats: 1,
        maxTeams: 0,
        canCollaborate: false,
        canCreateTeams: false,
        canInviteMembers: false,
        canShareDiagrams: false,
    },
    basic: {
        maxDiagrams: 20,
        maxSeats: 5,
        maxTeams: 1,
        canCollaborate: true,
        canCreateTeams: true,
        canInviteMembers: true,
        canShareDiagrams: true,
    },
    professional: {
        maxDiagrams: -1,
        maxSeats: -1,
        maxTeams: -1,
        canCollaborate: true,
        canCreateTeams: true,
        canInviteMembers: true,
        canShareDiagrams: true,
    },
};

export function getPlanRestrictions(planName) {
    const key = (planName || 'free').toLowerCase();
    return PLAN_RESTRICTIONS[key] || PLAN_RESTRICTIONS.free;
}
